import React, { useEffect } from "react";
import StatsCards from "./StatsCards";
import TopicsProgress from "./TopicsProgress";
import AIBanner from "./AIBanner";

const Dashboard = () => {
  useEffect(() => {
    // Animación de entrada
    const elements = document.querySelectorAll(".animate-fade");
    elements.forEach((el, index) => {
      setTimeout(() => {
        el.style.opacity = "1";
      }, index * 100);
    });
  }, []);

  return (
    <div className="space-y-10 animate-fade">
      <StatsCards />

      <div className="flex flex-col lg:flex-row gap-8">
        <TopicsProgress />
        {/*
        <AIBanner />
        */}
      </div>
    </div>
  );
};

export default Dashboard;
